// @flow
import * as React from 'react';

type Props = {
  children: React.Node,
  placeholder?: React.Node
};

type State = {
  isClient: boolean
};

export default class ClientOnly extends React.PureComponent<Props, State> {
  state = {
    isClient: false
  };

  componentDidMount() {
    // Use isClient to render client-side DOM changes in a second pass.
    // See: https://reactjs.org/docs/react-dom.html#hydrate
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({ isClient: true });
  }

  render() {
    return this.state.isClient
      ? this.props.children
      : this.props.placeholder || null;
  }
}
